<template>
  <div>
    <!--レイアウト変更-->
    <div class="row">
      <div class="col-6 col-md-4">
        <div class="d-grid gap-2 mx-auto">
          <button id="start" type="button" class="btn btn-outline-danger btn-lg" @click="E_Voice()">Start</button>
          <button id="stop" v-show="false" type=" button" class="btn btn-outline-danger btn-lg" disabled="true"></button>
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="d-grid gap-2 mx-auto">
          <!--（山中）uploadボタンをstopボタンに差し替え -->
          <button id="terminate" type="button" class="btn btn-outline-primary btn-lg" disabled="true"
            @click=terminateRecord()>Stop</button>
        </div>
      </div>
    </div>

    <br>
    <div class="row">
      <div class="row align-items-center">
        <div class="col-6 col-md-4">
          <Singer :is_singer="is_singer" :singer="singer"></Singer>
        </div>
        <div class="col-4 col-md-2">
          <Male :is_male="is_male" :male="male"></Male>
        </div>
        <!-- dbゲージ（山中） -->
        <div class="col-2 col-md-1">
          <dbBar :volume="volume"></dbBar>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8 mt-3">
        <Tone :is_tone="is_tone" :tone="tone"></Tone>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="col-md-8 mt-4">
          <Chart1 :chart-data="chartData1" :height="height1"></Chart1>
        </div>
      </div>
    </div>

    <!-- （長谷川） -->
    <div class="d-none">
      <div id="waveform"></div>
    </div>
  </div>
</template>

<script>
import { WaveFile } from 'wavefile';
import WaveSurfer from 'wavesurfer.js';
import _arrayBufferToBase64 from './ABtoB64'
import extract_on_time_bins from './extract_on_time_bins'
import make_feature from './make_feature'
import classify_tone from './classify_tone'
import classify_male from './classify_male'
import classify_singer from './classify_singer'
import Chart1 from './Chart1'
import Tone from './Tone.vue'
import Male from './Male.vue'
import Singer from './Singer.vue'
import dbBar from './dbBar.vue'


export default {
  name: 'Mid',
  components: {
    Chart1,
    Tone,
    Male,
    Singer,
    dbBar
  },
  data: function () {
    return {
      inputData: [],
      chartData1: { labels: [], datasets: [] },
      wavesurfer: null,
      height1: 200,
      width1: 600,
      is_tone: false,
      is_male: false,
      is_singer: false,
      // is_db_ok: false,
      volume: 0,
      tone: null,
      male: null,
      singer: null,
      tone_str: ["do", "re", "mi", "fa", "so", "la", "ti", "hido"],
      male_str: ["male", "female"],
      bintime: 0.1, // 1つのbinあたりの時間
      samplerate: 48000, // サンプルレート
      s0: 0.005, // s0秒以降のデータを使用
      s1: 0.22, // s1秒間のデータを使用
      bins: 2, // binの数
      step_time: 220, // 一回の推定あたり何ミリ秒録音するか
      start: null,
      length: null,
      end: null,
      binwidth: Math.round(this.samplerate * this.bintime),
      fft_size: 2 ** 13, // 実際にfftするサイズ
      use_fft_size: 1000,
      eps: 1e-5,
      limit_time: 60000, // 最大録音時間(ミリ秒),超えたら強制的にStop
      terminate_f: false, // trueなら強制終了させる
    }
  },
  mounted: async function () {
    this.wavesurfer = WaveSurfer.create({
      container: '#waveform',
      waveColor: 'violet',
      progressColor: 'purple',
      barHeight: 1.5,
      height: 100
    });
    //console.log(this.wavesurfer)
    //console.log("hoge2")
    await this.initChart();

    // window.setTimeout(function () { document.getElementById("terminate").click(); }, this.step_time);




    // const stopButton = document.getElementById("stop")
    // // stop button
    // document.getElementById("stop").addEventListener('click', function () {
    //   console.log('saved wav');
    // });
    // document.getElementById("terminate").addEventListener('click', function () {
    //   console.log('saved wav');
    // });
    // console.log("やあ");
    // stopButton.click();
    // document.getElementById("stop").click();
    // document.getElementById("terminate").click();

  },
  methods: {
    terminateRecord() {
      //console.log("terminateRecord");
      //console.clear();
      this.terminate_f = true;
    },
    terminate_E() {
      //console.log("Terminate");
      document.getElementById("start").disabled = false;
      document.getElementById("terminate").disabled = true;
      this.is_tone = false;
      this.is_male = false;
      this.is_db_ok = false;
      this.volume = 0;
      this.tone = null;
      this.male = null;
      this.singer = 0;
      this.initChart();
    },
    async E_Voice() {
      document.getElementById("start").disabled = true;
      document.getElementById("terminate").disabled = false;

      for (let cnt = 0; cnt < this.limit_time / this.step_time; cnt++) {
        if (this.terminate_f) {
          this.terminate_f = false;
          this.terminate_E();
          return;
        }
        await this.recordExecute();
        //console.log("end", cnt);
      }

      this.terminate_E();
    },
    async recordExecute() {
      // window.setTimeout(() => {
      //   document.getElementById("stop").click();
      // }, this.step_time);
      await this.startRecord()
        .then(this.loadBlobWavFile)
        .then(this.predict)
        .catch((e) => console.log(e));

      //console.log("recordExecute end");
      return true;
    },
    
    startRecord() {
      //console.log("loadBlobWavFile start");
      let step_time = this.step_time;

      return new Promise((resolve) => {
        // for html
        //const downloadLink = document.getElementById('download');
        const stopButton = document.getElementById('stop');

        // for audio
        let audio_sample_rate = null;
        let scriptProcessor = null;
        let audioContext = null;
        let rec = true;

        // audio data
        let audioData = [];
        let bufferSize = 1024;

        let saveAudio = function () {
          //console.log("saveaudio start")
          //（長谷川）let [wavdata, wavurl] = exportWAV(audioData);
          let [wavdata] = exportWAV(audioData);
          //downloadLink.url = wavurl;
          //downloadLink.download = 'test.wav';
          //（長谷川）console.log(wavurl);


          if (rec == true) {
            if (audioContext.state !== 'closed') { // (長谷川)AudioContextが閉じられていない場合にのみ処理を実行
              audioContext.close().then(function () {
                stopButton.setAttribute('disabled', 'disabled');
              });
            }
          }


          setTimeout(function () {
            resolve(wavdata)
          }, 10);
        }
        // export WAV from audio float data
        let exportWAV = function (audioData) {
          //console.log("exportWAV start")

          let encodeWAV = function (samples, sampleRate) {
            let buffer = new ArrayBuffer(44 + samples.length * 2);
            let view = new DataView(buffer);

            let writeString = function (view, offset, string) {
              for (let i = 0; i < string.length; i++) {
                view.setUint8(offset + i, string.charCodeAt(i));
              }
            };

            let floatTo16BitPCM = function (output, offset, input) {
              for (let i = 0; i < input.length; i++, offset += 2) {
                let s = Math.max(-1, Math.min(1, input[i]));
                output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
              }
            };

            writeString(view, 0, 'RIFF');  // RIFFヘッダ
            view.setUint32(4, 32 + samples.length * 2, true); // これ以降のファイルサイズ
            writeString(view, 8, 'WAVE'); // WAVEヘッダ
            writeString(view, 12, 'fmt '); // fmtチャンク
            view.setUint32(16, 16, true); // fmtチャンクのバイト数
            view.setUint16(20, 1, true); // フォーマットID
            view.setUint16(22, 1, true); // チャンネル数
            view.setUint32(24, sampleRate, true); // サンプリングレート
            view.setUint32(28, sampleRate * 2, true); // データ速度
            view.setUint16(32, 2, true); // ブロックサイズ
            view.setUint16(34, 16, true); // サンプルあたりのビット数
            writeString(view, 36, 'data'); // dataチャンク
            view.setUint32(40, samples.length * 2, true); // 波形データのバイト数
            floatTo16BitPCM(view, 44, samples); // 波形データ

            return view;
          };

          let mergeBuffers = function (audioData) {
            let sampleLength = 0;
            for (let i = 0; i < audioData.length; i++) {
              sampleLength += audioData[i].length;
            }
            let samples = new Float32Array(sampleLength);
            let sampleIdx = 0;
            for (let i = 0; i < audioData.length; i++) {
              for (let j = 0; j < audioData[i].length; j++) {
                samples[sampleIdx] = audioData[i][j];
                sampleIdx++;
              }
            }
            return samples;
          };

          let dataview = encodeWAV(mergeBuffers(audioData), audio_sample_rate);
          let audioBlob = new Blob([dataview], { type: 'audio/wav' });

          //let myURL = window.URL || window.webkitURL;
          //let url = myURL.createObjectURL(audioBlob);
          //return [audioBlob, url];
          return [audioBlob];
        };

        // stop button
        stopButton.addEventListener('click', function () {
          //console.log("stopbutton clicked");
          saveAudio();
          //console.log('saved wav');
        });

        // save audio data
        var onAudioProcess = function (e) {
          var input = e.inputBuffer.getChannelData(0);
          var bufferData = new Float32Array(bufferSize);
          for (var i = 0; i < bufferSize; i++) {
            bufferData[i] = input[i];
          }

          audioData.push(bufferData);
        };

        // getusermedia
        let handleSuccess = function (stream) {
          audioContext = new AudioContext();
          audio_sample_rate = audioContext.sampleRate;
          scriptProcessor = audioContext.createScriptProcessor(bufferSize, 1, 1);
          var mediastreamsource = audioContext.createMediaStreamSource(stream);
          mediastreamsource.connect(scriptProcessor);
          scriptProcessor.onaudioprocess = onAudioProcess;
          scriptProcessor.connect(audioContext.destination);

          //console.log('record start?');

          stopButton.removeAttribute('disabled');

          // let step_time = this.step_time
          //console.log(step_time)
          window.setTimeout(function () { document.getElementById("stop").click(); }, step_time);


        };

        // getUserMedia
        navigator.mediaDevices.getUserMedia({ audio: true, video: false })
          .then(handleSuccess);
      });
    },
    loadBlobWavFile(wavdata) {
      return new Promise((resolve, reject) => {
        // console.log(wavdata)
        // console.log(this.wavesurfer)
        this.wavesurfer.loadBlob(wavdata)

        const reader = new FileReader();
        reader.readAsArrayBuffer(wavdata);
        reader.onload = function () {
          if (reader.readyState === 1 || reader.readyState === 2) {
            let data1base64 = _arrayBufferToBase64(reader.result)
            let wav = new WaveFile();
            wav.fromBase64(data1base64);
            let audio16 = wav.getSamples(false, Int16Array);
            let amp = Math.pow(Math.pow(2, 8), 2) / 2.0;
            let audiofloat = new Array(audio16.length)
            for (let i = 0; i < audio16.length; i++) audiofloat[i] = audio16[i] / amp
            setTimeout(function () {
              resolve(audiofloat)
            }, 10);
          } else {
            reject(new Error("filereader error"));
          }
        };
        reader.onerror = function () {
          reject(new Error("filereader error"));
        };
      });
    },
    // upload() {
    //   document.getElementById("fileUpload").click();
    // },
    // loadSelectedWavFile(e) {
    //   return new Promise((resolve) => {
    //     let file = e.target.files;
    //     console.log(file[0])

    //     setTimeout(function () {
    //       resolve(file[0])
    //     }, 10);
    //   });
    // },
    selectExecute(e) {
      this.loadSelectedWavFile(e)
        .then(this.loadBlobWavFile)
        .then(this.predict)
        .catch((e) => console.log(e));
    },
    initChart() {
      let labelData = [];
      let feature = [];
      let tmp = [];
      for (let i = 0; i < this.use_fft_size; i++) {
        labelData.push(10 * (i + 1));
        tmp.push(0);
      }
      feature.push(tmp)
      this.drawChart1(feature, labelData)
    },
    execute(dataPath) {
      dataPath = dataPath.replace(".wav", "_53750.wav")
      this.loadWavFile(dataPath)
        .then(this.predict)
        .catch((e) => console.log(e));
    },
    // dataPathのWavFileを読み込み
    loadWavFile(dataPath) {
      return new Promise((resolve, reject) => {
        // console.log(dataPath)

        const request = new XMLHttpRequest();
        request.open('GET', dataPath, true)
        request.responseType = "arraybuffer";
        request.onload = function () {
          if (request.status === 200) {
            let data1base64 = _arrayBufferToBase64(request.response)
            let wav = new WaveFile();
            wav.fromBase64(data1base64);
            // console.log(wav.fmt);
            let audio16 = wav.getSamples(false, Int16Array);
            let amp = Math.pow(Math.pow(2, 8), 2) / 2.0;
            let audiodata = [];
            if (wav.fmt.numChannels == 1) {
              for (let i = 0; i < audio16.length; i++) audiodata[i] = audio16[i];
            }
            else {
              for (let i = 0; i < audio16[0].length; i++) audiodata[i] = (audio16[0][i] + audio16[1][i]) / (amp * 2)
            }
            // console.log(audiodata);
            setTimeout(function () {
              resolve(audiodata)
            }, 10);
          } else {
            reject(new Error(request.statusText));
          }
        };
        request.onerror = function () {
          reject(new Error(request.statusText));
        };
        request.send(null)
      });
    },
    // audiodataをもとに音階・性別・コーラス経験者を判別
    // audiodata：一次元float配列
    predict(audiodata) {
      return new Promise((resolve, reject) => {
        // 音声ファイルのうち，start ~ start + lengthだけ用いる
        this.start = Math.round(this.s0 * this.samplerate)
        this.length = Math.round(this.s1 * this.samplerate)
        this.end = this.start + this.length
        // 1つのbinに含まれるデータ数
        this.binwidth = Math.round(this.samplerate * this.bintime)

        ///change(yamanaka)
        // 最終的に使うfftされたデータ数
        this.use_fft_size = 1000

        if (audiodata == null) reject();
        this.inputData = audiodata
        // audiodataから必要な個数だけのbinを抽出し，平均音圧の高い順に並び替える
        let ontime = extract_on_time_bins(this.inputData, this.start, this.end, this.bins, this.binwidth)
        // binごとにDFTなどを行い，最終的にbinごとのパワースペクトル[dB]を得る
        // (山中) is_db_ok := ある一定の音量を超えているならtrue,そうでなければfalse
        //（長谷川）volume := 入力音量値
        let [feature, volume] = make_feature(ontime, this.bins, this.binwidth, this.fft_size, this.use_fft_size, this.eps);
        this.volume = volume;
        //console.log("volume", this.volume);
        // 一定以上の音量の時のみリフレッシュ
        if (volume >= 50) {
          let labelData = []
          for (let i = 0; i < feature[0].length; i++) {
            labelData.push(10 * (i + 1))
          }
          // 確認のためのパワースペクトル描画
          this.drawChart1(feature, labelData)
          // ここで判別
          this.tone = this.tone_str[classify_tone(audiodata, feature)]
          this.male = this.male_str[classify_male(audiodata, feature)]
          this.singer = classify_singer(audiodata, feature, this.male)
          this.is_tone = true
          this.is_male = true
          this.is_singer = true
          console.log("volume", this.volume);
          console.log("tone", this.tone);
          console.log("sex", this.male);
          console.log("score", this.singer);
        }
        else {
          this.is_tone = false;  //(長谷川)音量足りないとき、初期化
          this.tone = null;
          this.is_male = false;
          this.male = null;
          this.is_singer = false;
          this.singer = null;
          console.log("volume", this.volume);
        }
        setTimeout(function () {
          resolve();
        }, 10);
      })
    },
    drawChart1(feature, labelData) {
      var feature0 = new Array();
      for (let i = 0; i < labelData.length; i++) {
        feature0.push({ x: labelData[i], y: feature[0][i] })
      }
      // var feature1 = new Array();
      // for (let i = 0; i < labelData.length; i++) {
      //   feature1.push({ x: labelData[i], y: feature[1][i] })
      // }
      // var feature2 = new Array();
      // for (let i = 0; i < labelData.length; i++) {
      //   feature2.push({ x: labelData[i], y: feature[2][i] })
      // }
      this.chartData1 = {
        labels: labelData,
        datasets: [
          {
            label: 'sound 1',
            data: feature0,
            showLine: true,
            borderColor: 'rgba(60, 220, 150, 0.8)',
            lineTension: 0,
            pointRadius: 0,
            fill: false,
            type: "scatter"
          },
          // {
          //   label: 'sound 2',
          //   data: feature1,
          //   showLine: true,
          //   borderColor: 'rgba(255, 153, 0, 1)',
          //   lineTension: 0,
          //   pointRadius: 0,
          //   fill: false,
          //   type: "scatter"
          // },
          // {
          //   label: 'sound 3',
          //   data: feature2,
          //   showLine: true,
          //   borderColor: 'rgba(30, 220, 250, 0.8)',
          //   lineTension: 0,
          //   pointRadius: 0,
          //   fill: false,
          //   type: "scatter"
          // }
        ]
      }
    },
  }
};
</script>

<style>
/* .btn_sns {
  display: block;
  color: white;
  border-radius: 4px;
  text-decoration: none;
  padding: 6px 12px;
  font-size: 30px;
  width: 320px;
  margin-bottom: 16px;
  text-align: center;
} */

#start {
  border: red 2px solid;
}

/* #stop {
  cursor: pointer;
} */

/* uploadボタンをstopボタンに差し替え */
#terminate {
  border: blue 2px solid;
}

#sample {
  width: 60px;
}

#subtitle {
  margin-top: 16px;
  margin-bottom: 16px;
}

</style>
